import { FilterField, FilterPanel, CustomSelect } from '../common';

function PurchaseOrderFilters({
  values,
  suggestions,
  statusOptions,
  warehouseLocationOptions = [],
  onChange,
  onStatusChange,
  onSubmit,
  onReset,
}) {
  const branchWarehouseOptions = buildBranchWarehouseOptions(warehouseLocationOptions);

  return (
    <FilterPanel
      onSubmit={onSubmit}
      onReset={onReset}
      layoutClassName="grid gap-2.5 md:grid-cols-2 xl:grid-cols-[minmax(0,1.2fr)_210px_145px_145px_245px_auto]"
    >
      <FilterField
        label="Search"
        name="search"
        type="search"
        value={values.search}
        onChange={onChange}
        placeholder="Search P.O. code or supplier"
        suggestions={suggestions}
      />
      <CustomSelect
        label="Branch / Warehouse"
        name="branchWarehouse"
        value={values.branchWarehouse}
        onChange={onChange}
        options={branchWarehouseOptions}
        searchable
      />
      <FilterField
        label="P.O. Date"
        name="poDate"
        type="date"
        value={values.poDate}
        onChange={onChange}
      />
      <FilterField
        label="Delivery Date"
        name="deliveryDate"
        type="date"
        value={values.deliveryDate}
        onChange={onChange}
      />
      <CustomSelect
        label="Status"
        name="statusFilter"
        value={values.statusFilter}
        onChange={onStatusChange}
        options={[
          { value: 'Active', label: 'Initial + In Progress + Received' },
          { value: 'All', label: 'All Status' },
          ...statusOptions,
        ]}
        searchable={false}
      />
    </FilterPanel>
  );
}

function buildBranchWarehouseOptions(warehouseLocationOptions) {
  return [
    { value: 'All', label: 'All Branches / Warehouses' },
    ...warehouseLocationOptions.map((option) => {
      const branchName = String(option.branchName || '').trim();
      const warehouseName = String(option.value || option.label || '').trim();

      return {
        value: warehouseName,
        label: branchName ? `${branchName} - ${warehouseName}` : warehouseName,
      };
    }),
  ];
}

export default PurchaseOrderFilters;
